var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-snackbar',{attrs:{"value":_vm.toast,"color":_vm.color,"multi-line":_vm.mobile,"vertical":_vm.mobile,"timeout":-1}},[_vm._v(" "+_vm._s(_vm.message)+" "),_c('v-btn',{attrs:{"text":""},on:{"click":_vm.closeToast}},[_vm._v(" Close ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }